module.exports = __webpack_public_path__ + "media/images/comunicado_boleto-e3d8820ceff85cbb64d51502bf3fa90b.jpeg";